import React from 'react';
import { motion } from 'framer-motion';
import { PAIN_BLOCKS } from './salesData';
export function PainSection() {
  return <section className="bg-ivory py-12 sm:py-16" data-id="element-199" data-mp="38wlv6wefoyjb">
      <div className="mx-auto max-w-3xl px-5" data-id="element-200" data-mp="2uy5nb24u51zl">
        <div className="text-center" data-id="element-201" data-mp="2uxdrprb8n49b">
          <h2 className="font-display text-[1.45rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.1rem]" data-id="element-202" data-mp="2v0i0l1zneo6b">
            Sabés mucho de lo tuyo.
            <span className="mt-1 block text-gold-deep" data-id="element-203" data-mp="2l7khatmu0v6n">Pero eso no se ve en tus redes.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-sans text-[0.9rem] leading-relaxed text-charcoal/70 sm:text-base" data-id="element-204" data-mp="2q0ncf679ccoy">
            Si alguna de estas frases te suena conocida, no es falta de talento. Es que todavía no
            tenés un sistema para mostrar lo que sabés.
          </p>
        </div>

        <ul className="mt-8 grid gap-2.5 sm:grid-cols-2" data-id="element-205" data-mp="22a010ay4v4xn">
          {PAIN_BLOCKS.map((phrase, i) => <motion.li key={phrase} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.04
        }} className="flex gap-2.5 rounded-xl border border-stone bg-sand px-4 py-3.5 last:sm:col-span-2" data-id="element-206" data-mp="277rtb62owt2d" data-mpi={i}>
              <span className="font-display text-xl font-bold leading-none text-gold/50" aria-hidden data-id="element-207" data-mp="h95ur1u5rn0">
                “
              </span>
              <p className="font-sans text-[0.86rem] leading-relaxed text-charcoal/80" data-id="element-208" data-mp="33yhove8auxjb">{phrase}</p>
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 max-w-2xl text-center font-display text-base font-bold uppercase leading-snug text-charcoal sm:text-xl" data-id="element-209" data-mp="3io5q6fghdw71">
          El problema no es lo que sabés. Es que tu presencia digital todavía no lo comunica.
        </p>
      </div>
    </section>;
}